<template>
  <transition name="fade">
    <div
      v-show="isVisible"
      class="modal-overlay">
      <div class="modal-wrap">
        <slot />
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  data() {
    return {
      isVisible: false,
    };
  },

  methods: {
    toggleModal() {
      this.isVisible = !this.isVisible;
    },
  },
};
</script>

<style>
.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 39000;
  background: rgba(63, 76, 91, 0.397786);
  border: 1px solid #979797;
  -webkit-backdrop-filter: blur(5.43656px);
  backdrop-filter: blur(5.43656px);
}

.modal-wrap {
  position: absolute;
  right: 50%;
  bottom: 50%;
  width: 560px;
  height: auto;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #FFFFFF;
  padding: 16px 26px;
  box-shadow: 0px 4px 16px rgba(153, 153, 153, 0.25);
  border-radius: 24px;
  -webkit-transform: translateX(50%) translateY(50%);
  transform: translateX(50%) translateY(50%);
}

</style>



// WEBPACK FOOTER //
// src/components/modal/jModal.vue